import { Component } from '@angular/core';

@Component({
  selector: 'lp2-mini-lesson-tile-error',
  templateUrl: './mini-lesson-tile-error.component.html',
  styleUrls: ['./mini-lesson-tile-error.component.scss'],
})
export class MiniLessonTileErrorComponent {
  location = location;
}



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/mini-lesson-tile-error/mini-lesson-tile-error.component.ts